var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box12"},[_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.zixun('查看全部')}}},[_vm._v("查看全部")])])}
var staticRenderFns = []

export { render, staticRenderFns }